export const FETCH_CONVERSATION_BY_ID_REQUEST = "FETCH_CONVERSATION_BY_ID_REQUEST";
export const FETCH_CONVERSATION_BY_ID_SUCCESS = "FETCH_CONVERSATION_BY_ID_SUCCESS";
export const FETCH_CONVERSATION_BY_ID_FAILURE = "FETCH_CONVERSATION_BY_ID_FAILURE";

export const ADD_CONVERSATION_REQUEST = "ADD_CONVERSATION_REQUEST";
export const ADD_CONVERSATION_SUCCESS = "ADD_CONVERSATION_SUCCESS";
export const ADD_CONVERSATION_FAILURE = "ADD_CONVERSATION_FAILURE";

export const UPDATE_CHAT_REQUEST = "UPDATE_CHAT_REQUEST";
export const UPDATE_CHAT_SUCCESS = "UPDATE_CHAT_SUCCESS";
export const UPDATE_CHAT_FAILURE = "UPDATE_CHAT_FAILURE";

export const REGENERATE_CHAT_REQUEST = "REGENERATE_CHAT_REQUEST";
export const REGENERATE_CHAT_SUCCESS = "REGENERATE_CHAT_SUCCESS";
export const REGENERATE_CHAT_FAILURE = "REGENERATE_CHAT_FAILURE";

export const UPDATE_STAR_REQUEST = "UPDATE_STAR_REQUEST";
export const UPDATE_STAR_SUCCESS = "UPDATE_STAR_SUCCESS";
export const UPDATE_STAR_FAILURE = "UPDATE_STAR_FAILURE";

export const UPDATE_FEEDBACK_REQUEST = "UPDATE_FEEDBACK_REQUEST";
export const UPDATE_FEEDBACK_SUCCESS = "UPDATE_FEEDBACK_SUCCESS";
export const UPDATE_FEEDBACK_FAILURE = "UPDATE_FEEDBACK_FAILURE";

export const HIDE_CONVERSATION_PANE = "HIDE_CONVERSATION_PANE";
export const SHOW_CONVERSATION_PANE = "SHOW_CONVERSATION_PANE";

export const IS_CONVERSATION_UPDATED = "IS_CONVERSATION_UPDATED";

export const SET_DEFAULT_CONVERSATION = "SET_DEFAULT_CONVERSATION";
